import styles from './Order.module.css';

import { Card, Avatar } from '@mui/material';
import Scrollbar from '../../components/scrollbar';
// sections
// mock
import OrderDetails from './OrderDetailsBrandOwner';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import { useLayoutEffect } from 'react';
import GlobalModal from 'src/Modals/GlobalModal';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import Filter1 from '../Filter/Filter1';
import LiveLocation from 'src/pages/LiveLocation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axiosInstance from 'src/axiosInstance';
import bus from 'src/bus';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import { downloadFile2, shortenText } from 'src/utils';
import { Pagination } from 'src/components';
import MobileOrder from './MobileOrder';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'customerName', label: 'Customers', alignRight: false },
  { id: 'category', label: 'Category', alignRight: false },
  { id: 'productUnit', label: 'Product Items', alignRight: false },
  { id: 'customerLocation', label: 'Customer Location', alignRight: false },
  { id: 'price', label: 'Total Cost', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'order_confirmation', label: 'Order Confirmation', alignRight: false },
  { id: 'created_at', label: 'Date ordered', alignRight: false },
  { id: '' },
];
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

// ----------------------------------------------------------------------

// ptvo=PAGE TO VIEW (ORDER)
let app_view = localStorage.getItem('ptvo') ?? 0;
export default function OrderPage() {
  const navigate = useNavigate();
  const [appView] = useState(app_view);
  const [orderType, setOrderType] = useState('All');
  const [modalOpen, setModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchvalue, setSearchValue] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const [categoryPagination, setCategoryPagination] = useState({ total: 0 });
  const [dataFilter, setDataFilter] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [modalOpenConfirm, setModalOpenConfirm] = useState(false);
  const [modalOpenConfirm1, setModalOpenConfirm1] = useState(false);
  const [confirmOrder, setConfirmOrder] = useState(false);
  const [trx_id, setTrx_id] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [tooltipData, setToolTipData] = useState({ product_items: [] });
  const [tooltipLoading, setToolTipLoading] = useState(false);
  const [exporting, setExporting] = useState(false);

  const [filterSearch, setFilterSearch] = useState({
    location: '',
    status: '',
    category: '',
    min_price: '',
    max_price: '',
    min_order: '',
    max_order: '',
  });

  const notify = (msg) => toast.success(msg);
  const notifyError = (err) => toast.error(err);

  const searchFilter = (e) => {
    setSearchValue(e.target.value);
  };
  const [dataDetails, setDetailsData] = useState({
    completed: {
      current_order_count: 0,
      previous_order_count: 0,
      percentage_completed: 0,
    },
    abandoned: {
      current_order_count: 0,
      previous_order_count: 0,
      percentage_abandoned: 0,
    },
  });

  const handleCloseConfirm1 = () => {
    setModalOpenConfirm1(false);
  };
  const handleCloseConfirm = () => {
    setModalOpenConfirm(false);
  };

  const handleTrxChange = (event) => {
    setTrx_id(event.target.value);
  };

  const handleConfirmOrder = (val, order_number) => {
    setTrx_id(val);
    setOrderNumber(order_number);
    setModalOpenConfirm(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleStatusChange = (event) => {
    const { name, value } = event.target;
    setFilterSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useLayoutEffect(
    () => () => {
      localStorage.removeItem('ptvo');
    },
    []
  );

  const processLocation = (e) => {
    // console.log(e);
  };

  const handleViewClick = (val) => {
    localStorage.setItem('order_details_info', JSON.stringify(val));
    navigate('/app/order_details_brand');
  };

  const handleSendReminderClick = (val) => {
    // handle send reminder click action
    axiosInstance
      .get('/brand/order/send-reminder/' + val)
      .then((res) => {
        notify(res.data.message);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch {
          notifyError('Something went wrong, Please try again later');
        }
      });
  };
  const handleChange = (/* args passed from the child component */) => {
    handleViewClick(0);
  };

  const fetchCardDetails = (period = dataFilter) => {
    let periodValue = typeof period === 'object' ? 'today' : period;
    setIsPending(true);
    axiosInstance
      .get('/brand/order/cards?period=' + periodValue)
      .then((res) => {
        setDetailsData(res.data.data);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Unable to fetch analytics, please try again later');
        }
      })
      .finally(() => setIsPending(false));
  };

  const fetchData = async (
    page = 1,
    perpage = 10,
    search = searchvalue,
    file = null
  ) => {
    let filter_payload = {};
    if (filterSearch.status !== '') {
      filter_payload.status = filterSearch.status;
    }
    if (filterSearch.category !== '') {
      filter_payload.category = filterSearch.category;
    }
    if (filterSearch.min_price !== '') {
      filter_payload.min_price = filterSearch.min_price;
    }
    if (filterSearch.max_price !== '') {
      filter_payload.max_price = filterSearch.max_price;
    }
    if (filterSearch.location !== '') {
      filter_payload.location = filterSearch.location;
    }
    if (filterSearch.min_order !== '') {
      filter_payload.min_order = filterSearch.min_order;
    }
    if (filterSearch.max_order !== '') {
      filter_payload.max_order = filterSearch.max_order;
    }
    if (startDate && startDate !== '') {
      filter_payload.dateFrom = startDate;
    }
    if (endDate && endDate !== '') {
      filter_payload.dateTo = endDate;
    }
    if (file) {
      setExporting(true);
      let queryParams = new URLSearchParams({
        page,
        perpage,
        ...filter_payload,
        searchvalue,
        export_type: file,
      }).toString();

      try {
        await downloadFile2('All Orders', `/brand/order?${queryParams}`, file);
      } finally {
        // alert()
        setExporting(false);
      }
      return;
    }
    setIsPending(true);
    handleClose();
    axiosInstance
      .get('/brand/order?', {
        params: {
          page,
          perpage,
          ...filter_payload,
          searchvalue: search,
        },
      })
      .then((res) => {
        setOrderData(res.data.data.data);
        setCategoryPagination(res.data.data.pagination);
        setStartDate(null);
        setEndDate(null);
        setFilterSearch({
          location: '',
          status: '',
          category: '',
          min_price: '',
          max_price: '',
          min_order: '',
          max_order: '',
        });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Unable to fetch orders, please try again later');
        }
      })
      .finally(() => setIsPending(false));
  };

  useEffect(() => {
    bus.on('dataFilter', (el) => {
      // console.log(el);
      setDataFilter(el);
    });
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchvalue, reload]);

  useEffect(() => {
    fetchCardDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataFilter]);

  const processConfirmOrder = () => {
    setConfirmOrder(true);
    axiosInstance
      .post(`/brand/order/confirm/${trx_id}`, {
        order_number: orderNumber,
      })
      .then((res) => {
        handleCloseConfirm();
        notify(res.data.message);
        setReload(!reload);
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Something went wrong , please try again later');
        }
      })
      .finally(() => setIsPending(false));
  };

  const getHoverProduct = (id) => {
    setToolTipLoading(true);
    setToolTipData({ product_items: [] });
    axiosInstance
      .get(`/brand/order/on-hover/${id}`)
      .then((res) => {
        setToolTipData(res.data.data[0] || { product_items: [] });
      })
      .catch((err) => {
        try {
          notifyError(err.response.data.message);
        } catch (error) {
          notifyError('Something went wrong , please try again later');
        }
      })
      .finally(() => setToolTipLoading(false));
  };

  return Number(appView) === 0 ? (
    <>
      <div className="wrapper mt-4 px-2">
        <div className="header d-block d-md-none mb-4">
          <h4 className={`mb-0 pb-0`}>Orders</h4>
          <p className="text-muted" style={{ fontSize: '12px' }}>
            List of orders made by your customers
          </p>
        </div>

        <div className="header d-none d-md-flex justify-content-between mb-4">
          <div>
            <h4 className={`mb-0 pb-0`}>Orders</h4>
            <p className="text-muted" style={{ fontSize: '12px' }}>
              List of orders made by your customers
            </p>
          </div>
          <div className="d-flex" style={{ gap: '10px' }}>
            <button
              onClick={() => fetchData(currentPage, itemsPerPage, null, 'csv')}
              className="btn btn-primary py-2"
              disabled={exporting}
            >
              {exporting ? 'Exporting...' : 'Export to CSV'}
              {exporting && (
                <CircularProgress
                  style={{
                    width: '20px',
                    height: '20px',
                    marginLeft: '10px',
                    color: '#fff',
                  }}
                />
              )}
            </button>
            <button
              onClick={() => fetchData(currentPage, itemsPerPage, null, 'pdf')}
              className="btn btn-primary py-2"
              disabled={exporting}
            >
              {exporting ? 'Exporting...' : 'Export to PDF'}
              {exporting && (
                <CircularProgress
                  style={{
                    width: '20px',
                    height: '20px',
                    marginLeft: '10px',
                    color: '#fff',
                  }}
                />
              )}
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3 d-flex" style={{ gap: '10px' }}>
            <div className={`${styles.w_45}`}>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                placeholderText="Start Date"
                className="form-control"
              />
            </div>
            <div className={`${styles.w_45}`}>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                placeholderText="End Date"
                className="form-control"
              />
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-end mb-3">
            <div className={`${styles.search_box} me-2`}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                onChange={searchFilter}
                id="search"
              />
              <i className="bi bi-search"></i>
            </div>
            <div>
              <button
                className="btn btn-primary px-4"
                style={{
                  height: '100%',
                }}
                data-toggle="modal"
                data-target="#filterModal"
                onClick={() => setModalOpen(true)}
              >
                Filter
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="cards">
              <div
                className={`${styles.cards_val} card shadow-none h-100 p-0`}
                style={{
                  border: '1px solid #f0f0f0',
                }}
              >
                <div className="d-flex justify-content-between p-3">
                  <p>
                    All Orders
                    <i
                      className="bi bi-info-circle-fill"
                      style={{
                        marginLeft: '10px',
                      }}
                    ></i>
                  </p>
                  <div>
                    <select
                      name=""
                      id=""
                      className="form-control"
                      style={{
                        height: '30px',
                        fontSize: '10px',
                        padding: '0 5px',
                      }}
                    >
                      <option value="today">Today</option>
                      <option value="this_week">This week</option>
                      <option value="last_week">Last week</option>
                      <option value="last_month">Last Month</option>
                      <option value="this_month">This Month</option>
                      <option value="all_time">All Time</option>
                    </select>
                  </div>
                </div>
                <div className="p-3">
                  <div
                    className={`${styles.order_card} d-flex align-items-center justify-content-center`}
                  >
                    <div className="d-flex">
                      <div className="icon">
                        <i className="bi bi-box-seam"></i>
                      </div>
                      <div className="text-values">
                        <p>All Orders</p>
                        <p>12</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`${styles.cards_val} card shadow-none h-100 p-0`}
                style={{
                  border: '1px solid #f0f0f0',
                }}
              >
                <div className="d-flex justify-content-between p-3">
                  <p>
                    Pending Orders
                    <i
                      className="bi bi-info-circle-fill"
                      style={{
                        marginLeft: '10px',
                      }}
                    ></i>
                  </p>
                  <div>
                    <select
                      name=""
                      id=""
                      className="form-control"
                      style={{
                        height: '30px',
                        fontSize: '10px',
                        padding: '0 5px',
                      }}
                    >
                      <option value="">Today</option>
                      <option value="">This week</option>
                      <option value="">This Month</option>
                      <option value="">All Time</option>
                    </select>
                  </div>
                </div>
                <div className="p-3">
                  <div
                    className={`${styles.order_card} ${styles.order_pending} d-flex align-items-center justify-content-center`}
                  >
                    <div className="d-flex">
                      <div className="icon">
                        <i className="bi bi-calendar3-range"></i>
                      </div>
                      <div className="text-values">
                        <p>Pending Orders</p>
                        <p>5,423</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`${styles.cards_val} card shadow-none h-100 p-0`}
                style={{
                  border: '1px solid #f0f0f0',
                }}
              >
                <div className="d-flex justify-content-between p-3">
                  <p>
                    Completed Orders
                    <i
                      className="bi bi-info-circle-fill"
                      style={{
                        marginLeft: '10px',
                      }}
                    ></i>
                  </p>
                  <div>
                    <select
                      name=""
                      id=""
                      className="form-control"
                      style={{
                        height: '30px',
                        fontSize: '10px',
                        padding: '0 5px',
                      }}
                    >
                      <option value="">Today</option>
                      <option value="">This week</option>
                      <option value="">This Month</option>
                      <option value="">All Time</option>
                    </select>
                  </div>
                </div>
                <div className="p-3">
                  <div
                    className={`${styles.order_card} ${styles.order_completed} d-flex align-items-center justify-content-center`}
                  >
                    <div className="d-flex">
                      <div className="icon">
                        <i className="bi bi-check-circle"></i>
                      </div>
                      <div className="text-values">
                        <p>Completed Orders</p>
                        <p> {dataDetails.completed.current_order_count} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`${styles.cards_val} card shadow-none h-100 p-0`}
                style={{
                  border: '1px solid #f0f0f0',
                }}
              >
                <div className="d-flex justify-content-between p-3">
                  <p>
                    Abandoned Carts
                    <i
                      className="bi bi-info-circle-fill"
                      style={{
                        marginLeft: '10px',
                      }}
                    ></i>
                  </p>
                  <div>
                    <select
                      name=""
                      id=""
                      className="form-control"
                      style={{
                        height: '30px',
                        fontSize: '10px',
                        padding: '0 5px',
                      }}
                    >
                      <option value="">Today</option>
                      <option value="">This week</option>
                      <option value="">This Month</option>
                      <option value="">All Time</option>
                    </select>
                  </div>
                </div>
                <div className="p-3">
                  <div
                    className={`${styles.order_card} ${styles.order_abandoned} d-flex align-items-center justify-content-center`}
                  >
                    <div className="d-flex">
                      <div className="icon">
                        <i className="bi bi-x-lg"></i>
                      </div>
                      <div className="text-values">
                        <p>Abandoned Carts</p>
                        <p>{dataDetails.abandoned.current_order_count}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <Card
              style={{
                borderRadius: '10px',
              }}
              className="p-3"
            >
              <div
                className="d-flex align-items-center"
                style={{
                  borderBottom: '1px solid #f0f0f0',
                  paddingBottom: '15px',
                }}
              >
                <p
                  className="mb-0"
                  style={{
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }}
                >
                  Orders
                </p>
                <div className={`${styles.order_nav} ms-5`}>
                  <p
                    className={orderType === 'All' ? `${styles.active}` : ''}
                    onClick={() => setOrderType('All')}
                  >
                    All
                  </p>
                  <p
                    className={
                      orderType === 'Pending' ? `${styles.active}` : ''
                    }
                    onClick={() => setOrderType('Pending')}
                  >
                    Pending
                  </p>
                  <p
                    className={
                      orderType === 'Completed' ? `${styles.active}` : ''
                    }
                    onClick={() => setOrderType('Completed')}
                  >
                    Completed
                  </p>
                  <p
                    className={
                      orderType === 'Dispatched' ? `${styles.active}` : ''
                    }
                    onClick={() => setOrderType('Dispatched')}
                  >
                    Dispatched
                  </p>
                  <p
                    className={
                      orderType === 'Cancelled' ? `${styles.active}` : ''
                    }
                    onClick={() => setOrderType('Cancelled')}
                  >
                    Cancelled
                  </p>
                </div>
              </div>
              <Scrollbar>
                <div
                  className="p-2"
                  style={{
                    minWidth: '900px',
                  }}
                >
                  <div className={`${styles.table_header} row mx-0`}>
                    <div className="col-2">Customers</div>
                    <div className="col-2">Category</div>
                    <div className="col-2">Product Items</div>
                    <div className="col-2">Location</div>
                    <div className="col-1">Total Cost</div>
                    <div className="col-1">Status</div>
                    <div className="col-2">Order confirmation</div>
                  </div>

                  {!isPending && (
                    <div className="pt-3">
                      {orderData.length < 1 && (
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            height: '200px',
                          }}
                        >
                          <p>No orders found</p>
                        </div>
                      )}
                      {orderData.map((order, i) => {
                        return (
                          <div
                            key={i}
                            className={`${styles.table_row} row mx-0 align-items-center mb-3`}
                          >
                            <div className="col-2">
                              <div className="d-flex align-items-center">
                                <Avatar
                                  src={order.customer.photo_url}
                                  alt={order.customer.name}
                                  sx={{
                                    width: 30,
                                    height: 30,
                                    marginRight: '10px',
                                  }}
                                />
                                <div className="">
                                  <p className={`${styles.name} mb-0`}>
                                    {shortenText(order.customer.name, 15)}
                                  </p>
                                  <p
                                    className={`${styles.id} text-muted mb-0`}
                                  >
                                    {order.customer.shop_id}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="col-2">
                              <p className={`${styles.category} mb-0`}>
                                {order.category}
                              </p>
                            </div>
                            <div className="col-2">
                              <p className="mb-0">
                                {order.total_quantity} product items
                              </p>
                              <BootstrapTooltip
                                title={
                                  tooltipLoading ? (
                                    <p>loading...</p>
                                  ) : (
                                    <div
                                      style={{
                                        maxHeight: 200,
                                        overflowY: 'scroll',
                                      }}
                                    >
                                      {tooltipData.product_items.map(
                                        (el, i) => {
                                          return (
                                            <div
                                              key={i}
                                              className="d-flex justify-content-between my-2"
                                            >
                                              <p
                                                style={{
                                                  marginRight: 20,
                                                }}
                                              >
                                                {el.product_name}
                                              </p>
                                              <p>x{el.quantity}</p>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  )
                                }
                                placement="top"
                              >
                                <button
                                  className="btn btn-primary"
                                  style={{
                                    fontSize: '10px',
                                    padding: '2px 10px',
                                  }}
                                  onMouseOver={() =>
                                    getHoverProduct(order._id)
                                  }
                                >
                                  See items
                                </button>
                              </BootstrapTooltip>
                            </div>
                            <div className="col-2">
                              <p className="mb-0">
                                {order.customer.location.address}
                              </p>
                              <LiveLocation
                                handleProcess={processLocation}
                                coords={{
                                  lat: order.customer.location.lat,
                                  lng: order.customer.location.lng,
                                }}
                              />
                            </div>
                            <div className="col-1">
                              <p
                                className="mb-0"
                                style={{
                                  fontWeight: 'bold',
                                }}
                              >
                                {order.total_amount}
                              </p>
                            </div>
                            <div className="col-1">
                              <span
                                className={`${styles.status} ${
                                  order.status === 'pending'
                                    ? styles.pending
                                    : styles.completed
                                }`}
                              >
                                {order.status}
                              </span>
                            </div>
                            <div className="col-2">
                              {order.is_confirmed && (
                                <button className="btn btn-success">
                                  Order Confirmed
                                </button>
                              )}
                              {!order.is_confirmed && (
                                <button
                                  className="btn btn-primary"
                                  onClick={() =>
                                    handleConfirmOrder(order._id, order.order_id)
                                  }
                                >
                                  Confirm Order
                                </button>
                              )}
                              {order.is_delivered && (
                                <button className="btn btn-primary">
                                  Mark as delivered
                                </button>
                              )}
                            </div>
                            <div className="col-12">
                              <p className="text-muted text-end mb-0">
                                Order created:{' '}
                                {moment(order.created_at).format('ll')}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {isPending && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: '200px',
                      }}
                    >
                      <BallTriangle
                        height={50}
                        width={55}
                        radius={5}
                        color="#af3585"
                        ariaLabel="ball-triangle-loading"
                        wrapperClass={{}}
                        wrapperStyle=""
                        visible={true}
                      />
                    </div>
                  )}
                  {orderData.length > 0 && (
                    <Pagination
                      className="pagination-bar"
                      currentPage={currentPage}
                      totalCount={categoryPagination.total ?? 0}
                      pageSize={itemsPerPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  )}
                </div>
              </Scrollbar>
            </Card>
          </div>
        </div>
      </div>
      <GlobalModal
        open={modalOpenConfirm}
        handleClose={handleCloseConfirm}
        width={400}
      >
        <div className="container p-4">
          <div className="row">
            <div className="col-12 text-center">
              <h4
                style={{
                  fontWeight: 'bold',
                }}
              >
                Confirm Order
              </h4>
              <p>
                Are you sure you want to confirm order {orderNumber} ?. A notification
                will be sent to the customer that the order has been confirmed.
              </p>
              <div>
                <button
                  className="btn btn-primary w-100 mb-3"
                  onClick={processConfirmOrder}
                  disabled={confirmOrder}
                >
                  Confirm Order
                  {confirmOrder && (
                    <CircularProgress
                      style={{
                        width: '20px',
                        height: '20px',
                        marginLeft: '10px',
                        color: '#fff',
                      }}
                    />
                  )}
                </button>
                <button
                  className="btn btn-secondary w-100"
                  onClick={handleCloseConfirm}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </GlobalModal>
      <GlobalModal
        open={modalOpenConfirm1}
        handleClose={handleCloseConfirm1}
        width={400}
      >
        <div className="container p-4">
          <div className="row">
            <div className="col-12 text-center">
              <h4
                style={{
                  fontWeight: 'bold',
                }}
              >
                Cancel Order
              </h4>
              <p>
                Are you sure you want to cancel this order? This action cannot
                be undone.
              </p>
              <div className="form-group">
                <label htmlFor="reason">Reason for cancellation</label>
                <textarea
                  name="reason"
                  id="reason"
                  cols="30"
                  rows="5"
                  className="form-control"
                ></textarea>
              </div>
              <div>
                <button
                  className="btn btn-danger w-100 mb-3"
                  onClick={handleCloseConfirm1}
                >
                  Yes, Cancel
                </button>
                <button
                  className="btn btn-secondary w-100"
                  onClick={handleCloseConfirm1}
                >
                  No, Keep it
                </button>
              </div>
            </div>
          </div>
        </div>
      </GlobalModal>
      <Filter1
        open={modalOpen}
        handleClose={handleClose}
        handleStatusChange={handleStatusChange}
        handleFilter={fetchData}
        filterData={filterSearch}
        setFilterData={setFilterSearch}
      />
    </>
  ) : (
    <OrderDetails key="1" onChange={handleChange} />
  );
}
